import { ApiWidgetMetric } from "@/types/reporting/reporting.types.ts";
import {
  Button,
  DropdownMenu,
  DropdownMenuItem,
  FontAwesomeIcon,
  SelectItem,
} from "@skailer-com/uikit";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export interface HeadcountMetricSelectorProps {
  value: ApiWidgetMetric;
  onChange: (metric: ApiWidgetMetric) => void;
}

export function HeadcountMetricSelector({ value, onChange }: HeadcountMetricSelectorProps) {
  const { t } = useTranslation();

  const options: SelectItem[] = [
    {
      id: ApiWidgetMetric.headcount,
      title: t("reporting:metric_headcount"),
      icon: "fa-light fa-users",
    },
    {
      id: ApiWidgetMetric.headcount_growth_rate,
      title: t("reporting:metric_growth"),
      icon: "fa-light fa-arrow-trend-up",
    },
  ];

  const selectedOption = useMemo(
    () => options.find((x) => x.id === value) || options[0],
    [value, options]
  );

  return (
    <DropdownMenu
      trigger={
        <Button
          variant={"secondary"}
          rightIcon={<FontAwesomeIcon icon={"fa-light fa-chevron-down shrink-0"} />}
        >
          {selectedOption?.title}
        </Button>
      }
    >
      {options.map((option: SelectItem) => (
        <DropdownMenuItem
          key={`headcount-metric-${option.id}`}
          title={option.title}
          leftIcon={option.icon ? <FontAwesomeIcon icon={option.icon} /> : undefined}
          isSelected={selectedOption?.id === option.id}
          onClick={() => {
            onChange(option.id as ApiWidgetMetric);
          }}
        />
      ))}
    </DropdownMenu>
  );
}
